/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
ACC.autocomplete = {

  bindAll: function() {
    this.bindSearchAutocomplete();
  },

  bindSearchAutocomplete: function() {
    var $search = $('#search'),
        option = $search.data('options'),
        cache = {};

    if (option) {
    /* eslint-disable no-underscore-dangle */
      $search.autocomplete({
        /* eslint-enable no-underscore-dangle */
        minLength: option.minCharactersBeforeRequest,
        delay: option.waitTimeBeforeRequest,
        appendTo: '.siteSearch',
        /* eslint-disable consistent-return */
        source: function(request, response) {
          var term = request.term.toLowerCase();

          if (term in cache) {
            return response(cache[term]);
          }

          $.getJSON(option.autocompleteUrl, {
            term: request.term
          })
            .done(function(data) {
              var autoSearchData = [];

              if (data.suggestions !== null) {
                $.each(data.suggestions, function(index, obj) {
                  autoSearchData.push({
                    value: obj.term,
                    url: ACC.config.encodedContextPath + '/search?text=' + obj.term,
                    type: 'autoSuggestion'
                  });
                });
              }

              if (data.products !== null) {
                $.each(data.products, function(index, obj) {
                // Alert(obj.name + "\t "+ obj.code)
                  autoSearchData.push({
                    value: obj.name,
                    code: obj.code,
                    /* Desc: obj.description,
                    manufacturer: obj.manufacturer,*/
                    url: ACC.config.encodedContextPath + obj.url,
                    /* Price: obj.price.formattedValue,*/
                    type: 'productResult'
                  /* Image: obj.images[0].url*/
                  });
                });
              }

              cache[term] = autoSearchData;

              return response(autoSearchData);
            }).fail(function() {
              return false;
            });
        },
        focus: function() {
          return false;
        },
        select: function(event, uitem) {
          /* eslint-disable xss/no-location-href-assign */
          window.location.href = uitem.item.url;
          /* eslint-enable xss/no-location-href-assign*/
        }
      }).autocomplete('instance')._renderItem = function(ulindx, item) { // NOSONAR
        if (item.type === 'autoSuggestion') {
        /* eslint-enable consistent-return */
        /* eslint-disable xss/no-mixed-html */
        /* eslint-disable vars-on-top */
          var renderHtmlVar = '<a href=\'?q=' + item.value +
           '\' class=\'clearfix\' style=\'font-size:12px;padding:0px 0px;position:relative;vertical-align:middle;display:table-cell;height:35px;\'>' +
           item.value + '</a>';

          return $('<li class=\'suggestions\'>')
            .data('item.autocomplete', item)
            .append(renderHtmlVar)
            .appendTo(ulindx);/* eslint-enable xss/no-mixed-html */
          /* eslint-enable vars-on-top */
        }

        if (item.type === 'productResult') { /* eslint-disable max-len *//* eslint-disable vars-on-top *//* eslint-disable xss/no-mixed-html */
          var renderHtml = '<a href=\'' + item.url + '\' class=\'product clearfix\' style=\'font-size:12px;padding:0px 0px;position:relative;vertical-align:middle;display:table-cell;height:35px;\'>';

          if (option.displayProductImages && item.image !== null) {
            renderHtml = renderHtml + ('<span class=\'thumb\'><img src=\'' + item.image + '\' /></span><span class=\'desc clearfix\'>');
          }/* eslint-enable max-len *//* eslint-enable vars-on-top */

          renderHtml = renderHtml + ('<span class=\'title\' style=\'font-size:12px;\'>' + item.value +
            '</span>' +
            /* "<span class='price'>" + item.price + "</span>" +*/
            '</span>' +
            '</a>');

          return $('<li class=\'product\'>').data('item.autocomplete', item).append(renderHtml).appendTo(ulindx);
        }/* eslint-enable xss/no-mixed-html */
      };
    }
  }
};

$(document).ready(function() {
  ACC.autocomplete.bindAll();
});
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
